<script setup lang="ts">
import {onMounted, onUnmounted} from "vue";
import LogoIcon from "@/components/icons/navBarIcons/LogoIcon.vue";

function keyboardBlackHole(e: KeyboardEvent) {
  e.preventDefault();
  e.stopPropagation();
}

onMounted((() => {
  window.addEventListener("keydown", keyboardBlackHole)
}))
onUnmounted(() => {
  window.removeEventListener("keydown", keyboardBlackHole);
})
</script>
<template>
  <div class="tw-w-screen tw-h-screen tw-flex tw-justify-center tw-items-center tw-fixed tw-top-0 tw-left-0 tw-bg-black tw-opacity-80 tw-z-[99999]">
    <q-circular-progress
        show-value
        class="tw-m-4 tw-size-[280px] tw-text-[60px] mobile:tw-text-[50px] mobile:tw-size-[220px]"
        indeterminate
        :thickness="0.1"
        color="primary"
    >
      <q-avatar class="tw-bg-namaBackground-deep-light tw-size-[260px] mobile:tw-size-[205px]">
        <LogoIcon class="tw-p-5" is-spinner/>
      </q-avatar>
    </q-circular-progress>
  </div>
</template>
<style scoped>
</style>
